import { useTranslation } from 'react-i18next'
import './ErrorScreen.css'

interface ErrorScreenProps {
  message: string
  onRetry?: () => void
  onContactSupport?: () => void
}

export function ErrorScreen({ message, onRetry, onContactSupport }: ErrorScreenProps) {
  const { t } = useTranslation()

  return (
    <div className="error-screen">
      <div className="error-content">
        <div className="error-icon">⚠️</div>
        <h2>{t('error_occurred')}</h2>
        <p className="error-message">{message}</p>
        <div className="error-actions">
          {onRetry && (
            <button className="retry-button" onClick={onRetry}>
              {t('try_again')}
            </button>
          )}
          {onContactSupport && (
            <button className="support-button" onClick={onContactSupport}>
              {t('contact_support')}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}